<template>
  <div
    v-show="!isEmpty"
    class="c-gptBottomAd"
  >
    <div id="div-gpt-ad-1786526582999-0" />
  </div>
</template>

<script lang="ts">
let gptSlot: any = null
let isDisplayed = false
</script>

<script setup lang="ts">
const isEmpty = ref(true)

function handleSlotRenderEnded(event: any) {
  if (event.slot.getSlotElementId() === 'div-gpt-ad-1786526582999-0') {
    isEmpty.value = event.isEmpty
  }
}

onMounted(() => {
  window.googletag = window.googletag || { cmd: [] }
  window.googletag.cmd.push(() => {
    window.googletag.pubads().addEventListener('slotRenderEnded', handleSlotRenderEnded)

    if (!isDisplayed) {
      const existingSlot = window.googletag.pubads().getSlots()
        .find((s: any) => s.getSlotElementId() === 'div-gpt-ad-1786526582999-0')

      if (existingSlot) {
        gptSlot = existingSlot
      } else {
        gptSlot = window.googletag.defineSlot('/35101023/IM_PC_bottom_1st', [[300, 250], [336, 280]], 'div-gpt-ad-1786526582999-0')
          .addService(window.googletag.pubads())
        window.googletag.enableServices()
      }

      window.googletag.display('div-gpt-ad-1786526582999-0')
      isDisplayed = true
    } else if (gptSlot) {
      window.googletag.pubads().refresh([gptSlot])
    }
  })
})

onBeforeUnmount(() => {
  window.googletag?.pubads?.().removeEventListener('slotRenderEnded', handleSlotRenderEnded)
})
</script>

<style lang="scss" scoped>
.c-gptBottomAd {
  width: 336px;
  max-width: 100%;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
</style>
